module.exports = __webpack_public_path__ + "media/images/ibjjf/academy_registration_informations/head_professor-49e3421ad9dcbccf7ebc41c35e742746.svg";